import { Api } from '@/api/api';

export class ExportApi extends Api {
    public getClientDataAsync(partnerPracticeId: string | null): Promise<string> {
        return this.getFileAsync(`v1/export/client-data`, { partnerPracticeId });
    }

    public async getAppointmentDataAsync(partnerPracticeId: string | null): Promise<string> {
        return await this.getFileAsync(`v1/export/appointment-data`, { partnerPracticeId });
    }

    public async getCallDataAsync(partnerPracticeId: string | null): Promise<string> {
        return await this.getFileAsync(`v1/export/call-data`, { partnerPracticeId });
    }

    public async getDataReportAsync(partnerPracticeId: string | null): Promise<string> {
        return await this.getFileAsync(`v1/export/data-report`, { partnerPracticeId });
    }

    public async getDataCleanseExportAsync(partnerPracticeId: string | null): Promise<string> {
        return await this.getFileAsync(`v1/export/data-cleanse`, { partnerPracticeId });
    }

    public constructor() {
        super();
    }
}
